<script setup lang="ts">
const { cart } = useCart();
const { siteOptions } = useSiteOptions();
const count = computed(() => cart.value.cart_items.reduce((acc, item) => acc + item.quantity, 0));
</script>

<template>
  <UiNavButton v-if="siteOptions" as="a" :href="siteOptions.cart_url" :count="count" label="Mon panier">
    <span class="i-local-cart" />
    <template #count>
      <span class="cart-count">{{ count }}</span>
    </template>
  </UiNavButton>
</template>
